import React, { useState } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Popup from '../Common/Popup'
import { UserStatus } from '../../utils/config/user-enums'
import './AccountStatusModal.css'

interface ModelPropsType {
  isActive: boolean | undefined
  isPopupOpen?: boolean
  handleApiCall: (isBlocked: boolean) => void
}

const AccountStatusModal: React.FC<ModelPropsType> = ({
  isActive,
  handleApiCall,
  isPopupOpen,
}) => {
  const [showPopup, setShowPopup] = useState<boolean>(
    isPopupOpen ? true : false,
  )
  const [status, setStatus] = useState<string>(
    isActive ? UserStatus.ACTIVE : UserStatus.BLOCK,
  )

  const handleOpen = () => {
    setShowPopup(true)
  }

  const handleClose = () => {
    setShowPopup(false)
  }

  const UpdateStatus = () => {
    handleApiCall(status !== UserStatus.ACTIVE)
  }

  return (
    <>
      {showPopup && (
        <Popup
          title="Status Update Confirmation"
          message="Are you sure you want to change the status?"
          buttonText="Continue"
          showYesNoButtons={true}
          onYesClick={() => {
            UpdateStatus()
            handleClose()
          }}
          onNoClick={() => {
            handleClose()
            setStatus(
              status === UserStatus.ACTIVE
                ? UserStatus.BLOCK
                : UserStatus.ACTIVE,
            )
          }}
        />
      )}
      <div className="select-wrapper">
        <select
          value={status}
          onChange={(e) => {
            setStatus(e.target.value)
            handleOpen()
          }}
          className={`cursor-pointer status-dropdown w-full ${
            status === UserStatus.ACTIVE ? 'active2' : 'block2'
          }`}
        >
          <option value={UserStatus.ACTIVE}>{UserStatus.ACTIVE}</option>
          <option value={UserStatus.BLOCK}>{UserStatus.BLOCK}</option>
        </select>
        <ExpandMoreIcon className="absolute right-2 top-[50%] transform -translate-y-1/2 text-16px text-white pointer-events-none" />
      </div>
    </>
  )
}

export default AccountStatusModal
